import { isDefined } from '../typeUtils/index.js';
/**
 * Returns true when any segment of the path is exactly `..`, treating both `/`
 * and `\` as separators. Checking segments rather than substrings catches
 * traversal in trailing position (`packets/..`) while leaving dots inside a
 * name alone (`packet..pdf`, `..packets/packet.pdf`).
 */
export function hasDirectoryTraversal(filePath) {
    return isDefined(filePath) && filePath.split(/[/\\]/).includes('..');
}
//# sourceMappingURL=filePaths.js.map